  import moment from "moment";

  // * TIPO DE PERMISOS LICENCIAS.
  let tipoPermiso = {
    licenciaConDisfruteSueldo: 4,
    licenciaMedica: 5,
    licenciaSinDisfruteSueldo: 10,
    licenciaPermanente: 11
  };
  
  // * FUNCION PARA CALCULAR LOS DIAS LABORALES.
  export const calcularDiasHabiles = ({fechaInicio = new Date(), fechaTermino  = new Date(), diasFeriados, horaInicio  = new Date(), horaTermino  = new Date(), tipoPermisoId = 0, setValue}) => {
  
    // * VALIDACION DE SI EL PERMISO ES UNA LICENCIA.
    const esLicencia = Object.keys(tipoPermiso).some(key => parseInt(tipoPermiso[key]) === tipoPermisoId);
    
    // * FECHA DE INICIO Y FIN FORMATEADA.
    let start = moment(fechaInicio, "YYYY/MM/DD").startOf('day');
    let end = moment(fechaTermino, "YYYY/MM/DD").startOf('day');
    let diasHabiles = 0;

    if (esLicencia) {
      // * DESACTIVAR EL CORTEJO DE DIA COMPLETO
      setValue('diaCompleto', false);
      const diferenciaDias = end.diff(start, 'days') + 1;
      return diferenciaDias;
    }

    // * Convertimos los días feriados a formato de momento para facilitar la comparación
    const feriados = diasFeriados.map(dia => moment(dia.fecha, "YYYY/MM/DD"));
    const listadoFechas = generarRangoDeFechas(start, end);
    
    const startTime = moment(horaInicio, 'YYYY-MM-DD hh:mm:ss A');
    const endTime = moment(horaTermino, 'YYYY-MM-DD hh:mm:ss A');
    const hoursDifference = endTime.diff(startTime, 'hours');

    // * SI ES EL DIA COMPLETO QUE TOMAR EL USUARIO, EL RESULTADO SERA DE 0.
    if(start.isSame(end, 'day') && hoursDifference >= 8){
      setValue('diaCompleto', true);
      return 1;
    } 
    else if(start.isSame(end, 'day') && hoursDifference < 8){
      setValue('diaCompleto', false);
      return 0;
    }
    else{
      setValue('diaCompleto', false);
    }

    // * Iterar desde la fecha de inicio hasta la fecha de término, asegurando contar ambos extremos
    for (let index = 0; index <= listadoFechas.length; index++) {

      // * Convertimos fechaValidar a objeto moment para usar isoWeekday
      const fechaValidar = moment(listadoFechas[index], "YYYY/MM/DD");

      const esDiaHabil = fechaValidar.isoWeekday() >= 1 && fechaValidar.isoWeekday() <= 5;
      const esFeriado = feriados.some(feriado => feriado.isSame(fechaValidar, 'day'));

      if (esDiaHabil && !esFeriado) {
        diasHabiles++;
      }

    }

    return diasHabiles;
  }

  // * FUNCION PARA CALCULAR LOS DIAS LABORALES.
  export const calcularDiasHabilesFunc = ({fechaInicio, fechaTermino, diasFeriados, horaInicio, horaTermino, tipoPermisoId = 0}) => {
  
    // * VALIDACION DE SI EL PERMISO ES UNA LICENCIA.
    const esLicencia = Object.keys(tipoPermiso).some(key => parseInt(tipoPermiso[key]) === tipoPermisoId);
    
    // * FECHA DE INICIO Y FIN FORMATEADA.
    let start = moment(fechaInicio, "YYYY/MM/DD").startOf('day');
    let end = moment(fechaTermino, "YYYY/MM/DD").startOf('day');
    let diasHabiles = 0;

    if (esLicencia) {
      const diferenciaDias = end.diff(start, 'days') + 1;
      return diferenciaDias;
    }

    // * Convertimos los días feriados a formato de momento para facilitar la comparación
    const feriados = diasFeriados.map(dia => moment(dia.fecha, "YYYY/MM/DD"));
    const listadoFechas = generarRangoDeFechas(start, end);        
    
    const startTime = moment(horaInicio, 'YYYY-MM-DD hh:mm:ss A');
    const endTime = moment(horaTermino, 'YYYY-MM-DD hh:mm:ss A');
    const hoursDifference = endTime.diff(startTime, 'hours');

    // * SI ES EL DIA COMPLETO QUE TOMAR EL USUARIO, EL RESULTADO SERA DE 0.
    if(start.isSame(end, 'day') && hoursDifference >= 8){
      return 1;
    } 
    else if(start.isSame(end, 'day') && hoursDifference < 8){
      return 0;
    }

    // * Iterar desde la fecha de inicio hasta la fecha de término, asegurando contar ambos extremos
    for (let index = 0; index <= listadoFechas.length; index++) {

      // * Convertimos fechaValidar a objeto moment para usar isoWeekday
      const fechaValidar = moment(listadoFechas[index], "YYYY/MM/DD");

      const esDiaHabil = fechaValidar.isoWeekday() >= 1 && fechaValidar.isoWeekday() <= 5;
      const esFeriado = feriados.some(feriado => feriado.isSame(fechaValidar, 'day'));

      if (esDiaHabil && !esFeriado) {
        diasHabiles++;
      }

    }

    return diasHabiles;
  }
  
  
  // * FUNCION PARA GENERAR RANGO DE FECHAS
  const generarRangoDeFechas = (fechaInicio, fechaTermino) => {
    let start = moment(fechaInicio, "YYYY/MM/DD").clone();
    let end = moment(fechaTermino, "YYYY/MM/DD").clone();
    let rangoDeFechas = [];

    // Iterar desde la fecha de inicio hasta la fecha de término, incluyendo ambos extremos
    while (start.isBefore(end)) {
      rangoDeFechas.push(start.format("YYYY/MM/DD"));
      start.add(1, 'day');
    }
    
    // Aseguramos que el último día (fecha de término) se incluya en el rango
    rangoDeFechas.push(end.format("YYYY/MM/DD"));

    return rangoDeFechas;
  }
